import React, { useState, useEffect, useCallback } from 'react';
import { CircularProgress, IconButton, InputAdornment, withStyles } from '@material-ui/core';
import moment from 'moment';
import InputSearch from '../../../components/Input/Input';
import Scroll from '../../../components/InfiniteScroll/Scroll';
import { findAllProcedimentoSolicitado } from '../../../services/SolicitacaoProcedimentoService';
import { Clear, Search } from '@material-ui/icons';

const ProcedimentosSolicitadosTab = ({ classes, sujeitoAtencaoId }) => {
  const [procedimentos, setProcedimentos] = useState([]);
  const [page, setPage] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState('');

  const loadProcedimentos = useCallback(async (clear = false, searchValue) => {
    setLoading(true);
    try {
      const currentPage = clear ? 0 : page;
      const { last, content } = await findAllProcedimentoSolicitado({
        sujeitoAtencaoId,
        search: searchValue ?? search,
        pageableDto: {
          pageNumber: currentPage,
          pageSize: 30,
          sortDir: 'DESC',
          sortField: 'dataHoraLancamento',
        },
      });
      setProcedimentos(prev => clear ? content : [...prev, ...content]);
      setPage(clear ? 1 : currentPage + 1);
      setHasMore(!last);
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [page, search, sujeitoAtencaoId]);

  useEffect(() => {
    loadProcedimentos(true);
  }, [sujeitoAtencaoId]);

  const handleClickSearch = () => {
    loadProcedimentos(true, search);
  };

  const handleClickClear = () => {
    setSearch('');
    loadProcedimentos(true, '');
  };

  const onKeypressSearch = (e) => {
    if (e.key === 'Enter') {
      handleClickSearch();
    }
  };

  return (
    <div className={classes.content}>
      <div className={classes.searchContainer}>
        <InputSearch
          placeholder='Pesquisar procedimento'
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          classInputRoot={classes.inputSearch}
          startAdornment={
            <InputAdornment position="start">
              <IconButton className={classes.iconButtonSearch} onClick={handleClickSearch}>
                <Search />
              </IconButton>
            </InputAdornment>
          }
          endAdornment={search && (
            <InputAdornment position="end">
              <IconButton className={classes.iconButtonSearch} onClick={handleClickClear}>
                <Clear />
              </IconButton>
            </InputAdornment>
          )}
          onKeyPress={onKeypressSearch}
        />
      </div>
      {loading && procedimentos.length === 0 ? (
        <div className={classes.wrapperLoading}>
          <CircularProgress />
        </div>
      ) : (
        <Scroll
          loadMore={() => loadProcedimentos(false)}
          hasMore={hasMore}
          pageStart={0}
          initialLoad={false}
        >
          {procedimentos.map((item, index) => (
            <div key={index} className={classes.procedimentoItem}>
              <span className={classes.descricao}>
                {item.procedimento?.nome}
              </span>
              <span className={classes.data}>
                {moment(item.dataHoraLancamento).format('DD/MM/YYYY')}
              </span>
            </div>
          ))}
          {procedimentos.length === 0 && !loading && (
            <div className={classes.mensagemVazia}>Nenhum procedimento solicitado encontrado.</div>
          )}
        </Scroll>
      )}
    </div>
  );
};

const styles = {
  content: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    backgroundColor: '#FFFFFF',
    padding: '0 24px 24px 24px',
    overflowY: 'scroll',
  },
  searchContainer: {
    padding: '16px 0 8px',
  },
  inputSearch: {
    width: '100%',
    borderRadius: '8px',
    border: 'none',
    background: '#F2F2F2',
    padding: '0 8px',
  },
  iconButtonSearch: {
    padding: '6px',
  },
  procedimentoItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '12px 16px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.1)',
  },
  descricao: {
    fontSize: '14px',
    fontWeight: '600',
    color: '#505050',
  },
  data: {
    fontSize: '12px',
    color: '#868686',
  },
  mensagemVazia: {
    display: 'flex',
    justifyContent: 'center',
    padding: '20px',
    fontSize: '14px',
    color: '#868686',
  },
  wrapperLoading: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: 100,
  },
};

export default withStyles(styles)(ProcedimentosSolicitadosTab);
